// extracted by mini-css-extract-plugin
module.exports = {"mid-primary":"Tag_mid-primary__6pT_G"};